import { USER_DETAIL } from "../CONSTANTS";
import { getApiDataService } from "../../services/apiServices";

export const getAuthUserDetail = async () => {
  let user_id = sessionStorage.getItem("user_id");
  return getApiDataService(USER_DETAIL(user_id));
};

